import {apiAuth} from '../../services/ApiService'
import {createRequest} from '../../helpers/RequestHelper'

// http://192.168.24.119:9000/api/servidores/picture?cpf=3131
export function getImagemDoUsuario( onSuccess, onError ) {
    const path = `/servidores/picture`
    return createRequest({
        api: apiAuth, method: 'GET', path, onSuccess, onError
    });
}

// http://192.168.24.119:9000/api/servidores?cpf=700.625.294-63
export function getDadosDoUsuario( onSuccess, onError ) {
    const path = `/servidores`
    return createRequest({
        api: apiAuth, method: 'GET', path, onSuccess, onError
    });
}


// WEBPACK FOOTER //
// ./src/view/dashboard/UserActions.js